import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ChangePassword } from '../models/change-password.model';

@Injectable({
  providedIn: 'root',
})
export class MeService {
  constructor(private http: HttpClient) {}

  path = '/api/Me';

  getMyUserProfile(): Observable<any> {
    return this.http.get(`${environment.API}${this.path}/Profile`);
  }

  forgotPassword(email: string): Observable<any> {
    const path = '/api/User';
    return this.http.post(
      `${environment.API}${path}/ForgotPassword`,
      { email: email },
      {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
        }),
      }
    );
  }

  resetPassword(token: string, password: string): Observable<any> {
    const path = '/api/User';
    return this.http.post(
      `${environment.API}${path}/ResetPassword`,
      {
        token: token,
        password: password,
      },
      {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
        }),
      }
    );
  }

  changePassword(changePassword: ChangePassword): Observable<any> {
    const path = '/api/User';
    return this.http.post(`${environment.API}${path}/ChangePassword`, {
      newPassword: btoa(changePassword.newPassword),
      currentPassword: btoa(changePassword.currentPassword),
    });
  }
}
